import React, { useState } from "react";
import { checkTime } from "../constant/constant";
import "./home.css"
import { useDispatch,useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { faArrowRotateRight, faArrowTrendDown, faPlay, faPlus, faStar } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import CommonModalPopup from "./CommonaModalPopUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get_all_depends, msgPromtsuccess } from "../features/userSlice";
import { useT } from "../i18n";

const Home = () => {
  const { all_games,Info} = useSelector((state) => state.users);
  const [openModal,setOpenModal]=useState(false);
  const [content_type,setcontent_type]=useState( {content:''});
  const dispatch=useDispatch();
  const navigate=useNavigate();
  const canBet = Info?.status==='1';
  const { t } = useT();

  const closeModal=()=>{
    setOpenModal(false);
  }

  const getMygameUrl=(name,market_status)=>{
    if(market_status){
      let newName=name.split(' ').join('_');
      navigate(`/game_type/${newName}`);
    }else{
      dispatch(msgPromtsuccess({msg:`This Market Betting Is Closed For Today.`,error:true}));
      return false;
    }
  }

  const CommonModalOpener=(data)=>{
    setOpenModal(true);
    setcontent_type({
      content:data.TYPE,
      game_name:data.game_name,
      phone:data?.phone
    });
  }

  const refreshAll=()=>{
    let data = new FormData();
    data.append('phone_number',Info?.phone_number);
    dispatch(get_all_depends({request_type:'fetch_pofile',data}));
    dispatch(get_all_depends({request_type:'get_games',data}));
  }

  return(
    <div>
      {Info?.notification_head && <div className="hm-notice">
        <span className="hm-notice-track"><FontAwesomeIcon icon={faStar} />{Info.notification_head}</span>
      </div>}

      <div className="hm-actions">
        {canBet && <Link to="/add_fund_auto" className="hm-pill">
          <span className="hm-pill-icon"><FontAwesomeIcon icon={faPlus} /></span>{t('Add Money')}
        </Link>}
        <button type="button" className="hm-refresh-btn" onClick={refreshAll} aria-label={t('Refresh')}>
          <FontAwesomeIcon icon={faArrowRotateRight} />
        </button>
        {canBet && <Link to="/withdraw" className="hm-pill">
          <span className="hm-pill-icon"><FontAwesomeIcon icon={faArrowTrendDown} /></span>{t('Withdraw')}
        </Link>}
      </div>

      <div className="hm-contacts">
        {[Info?.helpNumber1, Info?.helpNumber2].filter(Boolean).map((phone, index)=>(
          <button type="button" key={index} className="hm-contact" onClick={()=>CommonModalOpener({TYPE:'CONNECT_SUPPORT',game_name:'',phone})}>
            <FontAwesomeIcon icon={faWhatsapp} />+91{phone}
          </button>
        ))}
      </div>

      <div className="hm-games">
        {all_games.map((data, index) => {
          const isOpen = data?.game_status!=='0' && checkTime(data.close_time);
          return (
            <div className="hm-card" key={index}>
              <span className={`hm-badge${isOpen?'':' closed'}`}>{isOpen?t('Betting is Running Now'):t('Betting is Closed for Today')}</span>
              <div className="hm-card-body">
                <div className="hm-card-info">
                  <h3 className="hm-name">{data.games_name}</h3>
                  <div className="hm-result">{data.open_pana}-{data.open_digit}{data.close_digit}-{data.close_pana}</div>
                  <div className="hm-times">
                    <span>{t('Open')} <b>{data.open_time}</b></span>
                    <span>{t('Close')} <b>{data.close_time}</b></span>
                  </div>
                </div>
                <div className="hm-card-actions">
                  {canBet && <button type="button" className={`hm-play-btn${isOpen?'':' closed'}`} aria-label={t('Play {name}',{name:data.games_name})} onClick={()=>getMygameUrl(data.games_name,isOpen)}>
                    <FontAwesomeIcon icon={faPlay} />
                  </button>}
                  <button type="button" className="hm-chart-btn" aria-label={t('{name} chart',{name:data.games_name})} onClick={()=>CommonModalOpener({TYPE:'CHART_INFO',game_name:data.games_name?.split(' ').join('_'),phone:Info?.helpNumber1})}>
                    <FontAwesomeIcon icon={faCalendarDays} />
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <CommonModalPopup
        isOpen={openModal}
        closeModal={closeModal}
        data={content_type}
      />
    </div>
  )};

export default Home;
